// extracted by mini-css-extract-plugin
export default {"EditButton":"PartList_EditButton__-yp1f"};